import OrganizacionService from '../../services/OrganizacionService'

const state = {
  organizaciones: [],
  organizacion: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 20
}

const getters = {
  organizaciones: state => state.organizaciones,
  organizacion: state => state.organizacion,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchAllOrganizaciones({ commit }) {
    try {
      const response = await OrganizacionService.getAllOrganizaciones()
      if (Array.isArray(response.data)) {
        commit('setOrganizaciones', response.data)
        return response
      } else if (response.data && Array.isArray(response.data.data)) {
        commit('setOrganizaciones', response.data.data)
        return response
      } else {
        console.error('Formato de respuesta inesperado:', response.data)
        throw new Error('Formato de respuesta inesperado')
      }
    } catch (error) {
      console.error('Error al obtener todas las organizaciones:', error)
      throw error
    }
  },
  
  async fetchOrganizaciones({ commit, state }, { page = 1, limit, filters = {} }) {
    try {
      const itemsPerPage = limit || state.itemsPerPage
      if (limit) {
        commit('setItemsPerPage', limit)
      }
      const response = await OrganizacionService.getOrganizaciones(page, itemsPerPage, filters)
      commit('setOrganizaciones', response.data.data)
      commit('setTotalItems', response.data.total || 0)
      commit('setCurrentPage', response.data.currentPage || page)
      return response
    } catch (error) {
      throw error
    }
  },

  async fetchOrganizacion({ commit }, id) {
    try {
      const response = await OrganizacionService.getOrganizacion(id)
      commit('setOrganizacion', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  },

  async createOrganizacion({ commit }, organizacion) {
    try {
      const response = await OrganizacionService.createOrganizacion(organizacion)
      return response
    } catch (error) {
      throw error
    }
  },

  async updateOrganizacion({ commit }, { id, organizacion }) {
    try {
      const response = await OrganizacionService.updateOrganizacion(id, organizacion)
      return response
    } catch (error) {
      throw error
    }
  },

  async deleteOrganizacion({ commit }, id) {
    try {
      const response = await OrganizacionService.deleteOrganizacion(id)
      return response
    } catch (error) {
      throw error
    }
  },

  async exportarListado({ commit }, { formato, filtros }) {
    try {
      const response = await OrganizacionService.exportarListado(formato, filtros)
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setOrganizaciones(state, organizaciones) {
    state.organizaciones = organizaciones
  },
  setOrganizacion(state, organizacion) {
    state.organizacion = organizacion
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}